import CreatableSelect from './creatable-select';

export default CreatableSelect;
